import MenuButton from '../MenuButton.jsx'
import useMenuItemAiAnalyseWorkload from './useMenuItemAiAnalyseWorkload.jsx'
import useMenuItemWorkloadByBd from './useMenuItemWorkloadByBd.jsx'
import useMenuItemWorkloadByBdlogic from './useMenuItemWorkloadByBdlogic.jsx'

export default function MenuButtonWorkload(props) {
    const items = [
        useMenuItemAiAnalyseWorkload(),
        useMenuItemWorkloadByBd(),
        useMenuItemWorkloadByBdlogic(),
    ]

    return (
        <MenuButton
            items={items}
            {...props}
        >
            AI评估工作量
        </MenuButton>
    )
}
